import iconPlus from 'assets/img/svg/plus.svg'
import iconMinus from 'assets/img/svg/minus.svg'
import mediasMixins from 'root/mixins/mediasMixin.js'
import facetsMixin from 'root/mixins/facetsMixin.js'
import closeImage from 'assets/img/svg/close.svg'

export default {
  name: 'facet-nav-applied-filters',
  mixins: [mediasMixins,facetsMixin],
  props: ['accordionactive', 'searchPageData'],
  data () {
    return {
      iconPlus: iconPlus,
      iconMinus: iconMinus,
      closeImage: closeImage,
      colorInverted: true
    }
  },

  methods: {
    clickAccordion (item) {
      this.$root.$emit('facet--accordion--item', item)
    },
    
    callApi(url, resetSorting = false) {
      this.$root.$emit('show--spinner--category--page')
      var decodedUrl = this.decodeHTML(url) 
      var searchPageDataUrl = decodedUrl.split("?").length > 1 ? (decodedUrl.split("?")[0] + '/getsearchpagedata?' + decodedUrl.split("?")[1]) : decodedUrl + '/getsearchpagedata'
      this.$http.post(searchPageDataUrl, {
        CSRFToken: this.$root.CSRFToken
      },{ emulateJSON: true }).then(response => {
        this.updateFacetData(response)
      }, error => {
        this.isLoading = false
        console.error(error)
      }).finally(() => {
        this.$root.$emit('hide--spinner--category--page')
        resetSorting && this.$root.$emit("reset-sorting")
      })      
    },
    
    removeFilters () {
      var url = location.protocol + '//' + location.host + location.pathname
      var paramText = this.$root.searchPageData.freeTextSearch
      if (paramText) {
        url = url + '?q=' + paramText
      }
      this.callApi(url, true)
    },
    
    submitForm (e, url) {
      e.preventDefault()
      this.callApi(url)
    },
  },

  computed: {
    showfilters() {
      return !!this.$root.searchPageData.breadcrumbs
    },
    
    pageData() {
      return this.$root.searchPageData || this.searchPageData
    },
    
    colorValues() {
      return this.breadcrumb.facetValueCode
    }
  },

  mounted: function () {
  },

  watch: {
  }
}



// WEBPACK FOOTER //
// ./web/webroot/_ui/responsive/common/js/src/components/facetnavappliedfilters/facetnavappliedfilters.js